export const buildTime = '2026-09-18 14:37:21 UTC';
